// If customers are not VIP but managed to add VIP products to cart, remove the VIP products on checkout

document.addEventListener('DOMContentLoaded', async () => {
    const vipProducts = Array.from(document.querySelectorAll(".cart__item[data-ako-not-vip='true']"));
    let updates = {};

    if (vipProducts.length === 0) return;
    
    vipProducts.forEach((product) => {
        const dataItemKey = product.getAttribute('data-item');
        updates = {
            ...updates,
            [dataItemKey]: 0
          };
        }
    )
   if (Object.keys(updates).length > 0) {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        })
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Cart updated successfully:', data);
    } catch (error) {
        console.error('Error updating cart:', error);
    }
   }
});